import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import axios from "axios";
import config from "../config";
import { useAuth } from "../context/AuthContext";

const EditLeadform = ({ leadData, onClose, onLeadUpdated }) => {
    const { accessToken, userId } = useAuth();

    // ✅ Form states
    const [leadName, setLeadName] = useState("");
    const [leadType, setLeadType] = useState(null);
    const [customLeadType, setCustomLeadType] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [requirement, setRequirement] = useState("");
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("Draft");
    const [loading, setLoading] = useState(false);

    // ✅ Dropdown options
    const leadTypes = [
        { label: "Weddings", value: "Weddings" },
        { label: "Social Media", value: "Social Media" },
        { label: "Website", value: "Website" },
        { label: "Motion Graphics", value: "Motion Graphics" },
        { label: "Static", value: "Static" },
        { label: "Others", value: "Others" }, // ✅ fixed spelling
    ];


    // ✅ Prefill data when leadData changes
    useEffect(() => {
        if (leadData) {
            const validLeadTypes = leadTypes.map((type) => type.value);

            // Check if the lead type from DB matches predefined ones
            if (validLeadTypes.includes(leadData.lead_type)) {
                setLeadType(leadData.lead_type);
                setCustomLeadType("");
            } else if (leadData.lead_type && leadData.lead_type.trim() !== "") {
                // Not matching any predefined → show "Others" and prefill the text field
                setLeadType("Others");
                setCustomLeadType(leadData.lead_type);
            } else {
                setLeadType(null);
                setCustomLeadType("");
            }

            setLeadName(leadData.lead_name || "");
            setPhoneNo(leadData.phone_no || "");
            setRequirement(leadData.requirement || "");
            setEmail(leadData.email || "");
            setStatus(leadData.status || "Draft");
        }
    }, [leadData]);



    // ✅ Update lead (PUT request)
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!leadName || !leadType || !phoneNo) {
            alert("Please fill in all required fields.");
            return;
        }

        const finalLeadType = leadType === "Others" ? customLeadType.trim() : leadType;

        if (leadType === "Others" && !customLeadType.trim()) {
            alert("Please specify the custom lead type.");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                lead_name: leadName,
                lead_type: finalLeadType, // ✅ stores the real text, never "Others"
                phone_no: phoneNo,
                requirement,
                email,
                status,
            };

            await axios.put(
                `${config.apiBASEURL}/Client_LeadRoutes/editclientlead/${leadData.Client_lead_id}`,
                payload,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            onLeadUpdated?.();
            onClose?.();
        } catch (error) {
            console.error("Error updating client lead:", error);
            alert("Failed to update client lead.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
                <h5 className="text-black">Edit Referral</h5>
                <Col lg="12" className="mb-0">
                    <Card className="shadow-0 p-0 border-0">
                        <Card.Body className="p-0">
                            {/* Lead Name */}
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Lead Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter lead name"
                                    value={leadName}
                                    onChange={(e) => setLeadName(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Lead Type */}
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Lead Type <span className="text-danger">*</span>
                                </Form.Label>
                                <Dropdown
                                    value={leadType}
                                    options={leadTypes}
                                    onChange={(e) => setLeadType(e.value)}
                                    placeholder="Select lead type"
                                    className="w-100"
                                />
                            </Form.Group>

                            {/* Custom Lead Type */}
                            {leadType === "Others" && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Specify Lead Type</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter custom lead type"
                                        value={customLeadType}
                                        onChange={(e) => setCustomLeadType(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            )}

                            {/* Phone Number */}
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Phone Number <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter phone number"
                                    value={phoneNo}
                                    onChange={(e) => setPhoneNo(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Email */}
                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Group>

                            {/* Requirement */}
                            <Form.Group className="mb-3">
                                <Form.Label>Requirement</Form.Label>
                                <InputTextarea
                                    rows={3}
                                    placeholder="Describe the requirement..."
                                    value={requirement}
                                    onChange={(e) => setRequirement(e.target.value)}
                                    className="w-100 h-auto"
                                />
                            </Form.Group>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Submit Button */}
                <Col lg="12" className="d-flex justify-content-end mt-3">
                    <Button
                        type="submit"
                        label={loading ? "Updating..." : "Update"}
                        icon="pi pi-save"
                        severity="info"
                        className="py-2"
                        disabled={loading}
                    />
                </Col>
            </Row>
        </Form>
    );
};
export default EditLeadform